import {Component, Input, OnInit} from '@angular/core';
import {ViewCell} from 'ng2-smart-table';
import {ApiService} from '../../../../@core/service/api.service';

@Component({
  selector: 'ngx-form-list-project-renderer',
  template: '{{renderValue != null ? (renderValue | date:\'MMM dd, yyyy\') : ""}}',
})
export class FormListDateRendererComponent implements ViewCell, OnInit {
  renderValue: string;

  @Input() value: any;
  @Input() rowData: any;

  constructor(private api: ApiService) {

  }


  ngOnInit() {
    this.renderValue = this.value != null ? this.value : null;
  }

}
